import axios from 'axios'

const publicKey = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY || import.meta.env.VITE_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

export async function registerPushNotifications(apiBase, appName = 'melcaisse') {
  const token = localStorage.getItem('jwtToken')

  if (!token || !publicKey || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    return
  }

  if (Notification.permission === 'denied') {
    return
  }

  const permission = Notification.permission === 'granted'
    ? 'granted'
    : await Notification.requestPermission()

  if (permission !== 'granted') {
    return
  }

  const registration = await navigator.serviceWorker.ready
  let subscription = await registration.pushManager.getSubscription()

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    })
  }

  await axios.post(`${apiBase}push-subscriptions`, {
    app: appName,
    subscription: subscription.toJSON(),
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
